export const MEALS_PER_PAGE = 12;

export const GLASS_PANEL =
  "bg-white dark:bg-gray-800/50 backdrop-blur-lg rounded-2xl shadow-xl border border-slate-200/50 dark:border-slate-600/50";
